import { Box, Text, styled } from "prism-react";
import * as React from "react";

import type { SuiteResults, TestResults } from "./types";

interface Props {
  suites: SuiteResults;
  tests: TestResults;
  duration: number;
}

const StyledLabel = styled(Text, {
  fontWeight: "$semibold",
  color: "$neutral-fg-base",
  whiteSpace: "pre-wrap",
});

export const Summary: React.FC<Props> = ({ suites, tests, duration }) => {
  const widestLabel = "Test suites: ";

  const withMargin = (label: string): string => {
    const difference = widestLabel.length - label.length;
    const margin = Array.from({ length: difference }, () => " ").join("");
    return label + margin;
  };

  return (
    <Box css={{ fontWeight: "$semibold", color: "$neutral-bg-subtle" }}>
      <Box css={{ marginBottom: "$2" }}>
        <StyledLabel>{widestLabel}</StyledLabel>
        {suites.fail > 0 && (
          <Text color="informative-error-base">{suites.fail} failed, </Text>
        )}
        {suites.pass > 0 && (
          <Text color="informative-success-base">{suites.pass} passed, </Text>
        )}
        <Text color="neutral-fg-high">{suites.total} total</Text>
      </Box>
      <Box css={{ marginBottom: "$2" }}>
        <StyledLabel>{withMargin("Tests:")}</StyledLabel>
        {tests.fail > 0 && (
          <Text color="informative-error-base">{tests.fail} failed, </Text>
        )}
        {tests.skip > 0 && (
          <Text color="informative-warning-base">{tests.skip} skipped, </Text>
        )}
        {tests.pass > 0 && (
          <Text color="informative-success-base">{tests.pass} passed, </Text>
        )}
        <Text color="neutral-fg-high">{tests.total} total</Text>
      </Box>
      <StyledLabel>
        {withMargin("Time:")}
        {duration / 1000}s
      </StyledLabel>
    </Box>
  );
};
